import { render, staticRenderFns } from "./MyOffersView.vue?vue&type=template&id=322587c2&scoped=true"
import script from "./MyOffersView.vue?vue&type=script&lang=js"
export * from "./MyOffersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322587c2",
  null
  
)

export default component.exports